<template>
  <nav v-if="!isPhone" class="HeaderBar" 
    :style="{ 
      'background-image': 'url('+ APPLICATION_PATH + BANNER_PATH +')',
      'background-color': COR_FUNDO_TOPO,
      'height': ALTURA_BANNER+'px',
      'min-height': ALTURA_BANNER+'px' }">

    <button class="btn-switch-mode" :style="{ 'min-height': ALTURA_BANNER+'px', 'height': ALTURA_BANNER+'px' }" :title="info['title']" @click="info['onClick']" :aria-label="info['aria-label']" tabindex="0">
      <div class="arrow" />
      <i class="material-icons">{{ info['icon'] }}</i>
    </button>
    
    <slot></slot>
  </nav>
</template>

<script>
import {
  APPLICATION_PATH,
  BANNER_PATH,
  ALTURA_BANNER,
  COR_FUNDO_TOPO,
} from '@/const'

export default {
  name: 'HeaderBar',
  props: {
    mode: {
      default: 'publication', // 'publication' or 'map'
      type: String,
    }
  },
  data() {
    return {
      APPLICATION_PATH,
      BANNER_PATH,
      ALTURA_BANNER,
      COR_FUNDO_TOPO,
    }
  },
  computed: {
    info () {
      let info = {
        'publication': {
          'aria-label': "Alternar modo, ir para mapa",
          title: "Ir para mapa interativo",
          onClick: this.onClick_goToMap,
          icon: 'language',
        },
        'map': {
          'aria-label': "Alternar modo, ir para publicação",
          title: "Voltar para publicação",
          onClick: this.onClick_goToPublication,
          icon: 'import_contacts',
        }
      }

      return info[this.mode]
    }
  },
  methods: {
    onClick_goToPublication (event) {
      this.$router.push({
        name: 'home'
      })
    },

    onClick_goToMap (event) {
      this.$router.push({
        name: 'map'
      })
    },
  }
}
</script>